// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3kl1V","label":"Section_label__1iAc4","contentWrap":"Section_contentWrap__26dFP","footer":"Section_footer__25svU","footerInner":"Section_footerInner__3pIbl"};